import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppValidators } from '../../../../core/validators/app-validators';
import constants from '../../../../utility/constants';
import { CommonDropdown, GetAuctionStep1 } from '../../../../models';
import { LoaderService, LotService, AddLotModel } from '../../../../services';
import { ToastrService } from 'ngx-toastr';
import {  Subscription } from 'rxjs';
@Component({
  selector: 'app-lot-form',
  templateUrl: './lot-form.component.html',
  styleUrls: ['./lot-form.component.css'],
})
export class LotFormComponent implements OnInit {
  @Input() auctionId: number;
  @Input() lotId: number;
  @Input() auctionData: GetAuctionStep1;
  @Output('lotFormStep1Completed') step1Completed = new EventEmitter<any>();

  loading: boolean = false;
  publishLoading: boolean = false;
  submitting: boolean = false;

  private lotType: number = 1;

  lotForm: FormGroup;

  lotsForDD: Array<CommonDropdown>;

  fieldMaxLengthShort: number = constants.common.validations.maxLength50;
  mobileNumberLength: number =
    constants.common.validations.maxLengthMobileNumber;
  fieldVeryShortMaxLength: number = constants.common.validations.maxLength10;
  fieldMaxLength: number = constants.common.validations.maxLength100;
  fieldMaxLength200: number = constants.common.validations.maxLength200;
  fieldMaxLengthMedium: number = constants.common.validations.maxLength500;
  fieldMaxLengthLong: number = constants.common.validations.maxLength1500;
  fieldMaxLengthLonger: number = constants.common.validations.maxLength2500;
  fieldMaxLengthLongest: number = constants.common.validations.maxLength8000;
  fieldLengthForPrices: number = 3;
  isDisabled: boolean;
  message: string;
  private subscriptions: Array<Subscription> = [];
  constructor(
    private loaderService: LoaderService,
    private lotService: LotService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.initiatelotForm();
    this.lotsListingForDD();

    if (this.lotId) this.getLotDataById();
  }

  private initiatelotForm() {
    this.lotForm = new FormGroup({
      id: new FormControl(0),
      lotNumbers: new FormControl(null, [
        AppValidators.noWhitespace,
        Validators.required,
        Validators.maxLength(this.fieldVeryShortMaxLength),
        AppValidators.checkLotNumber,
      ]),
      lotNumberAfterWhichThisWillBeAdded: new FormControl('', [
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldVeryShortMaxLength),
      ]),
      description: new FormControl(null, [
        AppValidators.noWhitespace,
        Validators.required,
        Validators.maxLength(this.fieldMaxLengthLongest),
      ]),
      location: new FormControl(null, [
        AppValidators.noWhitespace,
        Validators.required,
        Validators.maxLength(this.fieldMaxLength200),
      ]),
      category: new FormControl(null, [
        AppValidators.noWhitespace,
        Validators.required,
        Validators.maxLength(this.fieldMaxLengthShort),
      ]),
      consigner: new FormControl(null, [
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldMaxLengthShort),
      ]),
      reserve: new FormControl(null, [
        AppValidators.noWhitespace,
        AppValidators.onlyNumeric
      ]),
      quantity: new FormControl(null, [
        AppValidators.noWhitespace,
        Validators.required,
        AppValidators.onlyNumeric,
      ]),
      openingPrice: new FormControl(null, [
        AppValidators.noWhitespace,
        AppValidators.onlyNumeric
      ]),
      isDeleted: new FormControl(false),
    });
  }

  private lotsListingForDD() {
    this.lotService
      .getLotsByAuction(this.auctionId, this.lotType)
      .toPromise()
      .then((response: CommonDropdown[]) => {
        this.lotsForDD = response;
      });
  }

  private getLotDataById() {
    this.loaderService.showLoader(true);
    const vlots = this.lotService.viewLotById(this.lotId).subscribe(
      (res) => {
        this.mapDataToForm(res);
        this.loaderService.showLoader(false);
      },
      () => {
        this.loaderService.showLoader(false);
      }
    );
    this.subscriptions.push(vlots);
  }

  mapDataToForm(lotData: any) {
    this.lotForm.patchValue({
      id: lotData.id,
      lotNumbers: lotData.lotNumber,
      description: lotData.description,
      location: lotData.location,
      category: lotData.category,
      consigner: lotData.consignor,
      openingPrice: lotData.openingPrice,
      reserve: lotData.reservePrice,
      quantity: lotData.quantity,
      lotNumberAfterWhichThisWillBeAdded:
        lotData.lotNumberAfterWhichThisWillBeAdded,
    });

    if (lotData.addedInBulkLotId) this.lotForm.controls.reserve.disable();
  }

  private createAddLotModel(isPublishLot): AddLotModel {
    let formValues = this.lotForm.getRawValue();
    let model: AddLotModel = {
      isUpdateAndPublish: isPublishLot,
      auctionId: this.auctionId,
      consignor: formValues.consigner,
      category: formValues.category,
      description: formValues.description,
      location: formValues.location,
      lotId: this.lotId || 0,
      lotNumber: formValues.lotNumbers,
      lotType: this.lotType,
      openingPrice:
        formValues.openingPrice != null ? +formValues.openingPrice : null,
      reservePrice: formValues.reserve != null ? +formValues.reserve : null,
      quantity: +formValues.quantity,
      lotNumberAfterWhichThisWillBeAdded:
        +formValues.lotNumberAfterWhichThisWillBeAdded || 0,
    };
    return model;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }

  addUpdateLot(isPublishLot) {
    this.submitting = true;

    if (this.lotForm.invalid) return;

    this.submitting = false;
    if (isPublishLot) this.publishLoading = true;
    else this.loading = true;

    const clots = this.lotService
      .addUpdateLot(this.createAddLotModel(isPublishLot))
      .subscribe(
        (res: any) => {
          if (isPublishLot) this.publishLoading = false;
          else this.loading = false;
          this.lotForm.reset();
          this.stepCompleted(res);
        },
        (err) => {
          if (isPublishLot) this.publishLoading = false;
          else this.loading = false;
          this.toastr.error(err, 'Error');
        }
      );
      this.subscriptions.push(clots);
  }

  getClosingBeginsData(auctionEndDate) {
    let currentDate = new Date().getTime();
    let auctionendDate = new Date(auctionEndDate).getTime();
    if (currentDate < auctionendDate && this.lotsForDD?.length > 0) {
      this.isDisabled = false;
      this.message = 'applicable only when lot closing has not started.';
      return true;
    } else if (currentDate < auctionendDate && this.lotsForDD?.length == 0) {
      this.isDisabled = true;
      this.message =
        'No lot present in this auction, Lot will be added at first position.';
      return true;
    } else if (currentDate > auctionendDate && this.lotsForDD?.length > 0) {
      this.isDisabled = true;
      this.message =
        'Auction closing Started, So lot will be added in the last.';
      return true;
    } else if (currentDate > auctionendDate && this.lotsForDD?.length == 0) {
      this.isDisabled = true;
      this.message =
        'Auction closing Started, So lot will be added at first position.';
      return true;
    }
  }

  stepCompleted(lotData: any) {
    this.step1Completed.emit(lotData);
  }
}
